import { render, staticRenderFns } from "./ModalNovoContrato.vue?vue&type=template&id=8915a9ea&scoped=true"
import script from "./ModalNovoContrato.vue?vue&type=script&lang=ts"
export * from "./ModalNovoContrato.vue?vue&type=script&lang=ts"
import style0 from "./ModalNovoContrato.vue?vue&type=style&index=0&id=8915a9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8915a9ea",
  null
  
)

export default component.exports